import posthog from "posthog-js";
import { axiosBasic, getUserInfo } from "../../../api/axios";
import { config } from "../../../api/endPoints";
import { actionTypes } from "./departmentActionTypes";
import { UPDATE_PAGING } from "../../common/pagination/paginationActionTypes";
import { Common } from "../../../utils";
const { Department } = config.REST_API;
const getAllDepartment = department => {
  return { type: actionTypes.SHOW_DEPARTMENT_LIST, department };
};
export const isEditDep = val => {
  return { type: actionTypes.IS_EDIT_DEP, val };
};
export const depBtnLoading = val => {
  return { type: actionTypes.DEP_BTN_LOADING, val };
};
export const depBtnDisable = val => {
  return { type: actionTypes.DEP_BTN_DISABLE, val };
};
const deleteDepartment = department => {
  return { type: actionTypes.DELETE_DEPARTMENT, department };
};
export const clearFields = () => {
  return { type: actionTypes.CLEAR_FIELDS };
};
export const loadStart = () => {
  return { type: actionTypes.LOADING_START };
};

export const loadStop = () => {
  return { type: actionTypes.LOADING_STOP };
};
export const edit = department => {
  return dispatch => {
    dispatch({ type: "FIELD_STATE_TRUE" });
    dispatch({ type: actionTypes.EDIT_DEPARTMENT, department });
  };
};

// Get Department List From Api and Bind with Department Grid
export const DepartmentListing = (options, currentPage) => {
  let newUrl =
    Department.Get +
    options.start +
    "/" +
    options.page +
    "/" +
    options.limit;
  return dispatch => {
    const userId = getUserInfo()?.selfUserId ?? null;
    const userInput = { start: options.start, page: options.page, limit: options.limit, currentPage };
    dispatch({ type: actionTypes.LOADING_START });
    axiosBasic
      .get(newUrl)
      .then(response => {
        const baseModel = response.data;
        const success = baseModel.success;
        if (typeof posthog !== "undefined" && posthog.capture) {
          posthog.capture("DepartmentListing", {
            type: success ? "info" : "exception",
            userId,
            success,
            userInput,
            reason: success ? undefined : baseModel.message,
          });
        }
        if (success) {
          dispatch({
            type: UPDATE_PAGING,
            payload: { data: { total: baseModel.total, currentPage } }
          });
          dispatch(getAllDepartment(baseModel.data));
        } else {
          Common.showErrorMessage(baseModel.message);
        }
      })
      .catch(error => {
        if (typeof posthog !== "undefined" && posthog.capture) {
          posthog.capture("DepartmentListing", {
            type: "exception",
            userId,
            success: false,
            userInput,
            reason: error?.response?.data?.message ?? error?.message ?? "Request failed",
          });
        }
        Common.showErrorMessage("Something went wrong");
        console.log(error);
      });
  };
};

export const saveDepartment = department => {
  const obj = {
    Name: department.name.trim(),
    Notes: department.notes.trim(),
  };
  return dispatch => {
    const userId = getUserInfo()?.selfUserId ?? null;
    const userInput = { hasName: !!(department?.name?.trim()), hasNotes: !!(department?.notes?.trim()) };
    dispatch({ type: actionTypes.LOADING_START });
    return axiosBasic
      .post(Department.Create, obj)
      .then(response => {
        const res = response.data;
        const success = res.success;
        if (typeof posthog !== "undefined" && posthog.capture) {
          posthog.capture("saveDepartment", {
            type: success ? "info" : "exception",
            userId,
            success,
            userInput,
            reason: success ? undefined : res.message,
          });
        }
        if (success) {
          // Add the new department to the local state
          dispatch({ type: actionTypes.ADD_DEPARTMENT_SUCCESS, department: res.data });
        }
        dispatch({ type: actionTypes.LOADING_STOP });
        return res;
      })
      .catch(error => {
        if (typeof posthog !== "undefined" && posthog.capture) {
          posthog.capture("saveDepartment", {
            type: "exception",
            userId,
            success: false,
            userInput,
            reason: error?.response?.data?.message ?? error?.message ?? "Request failed",
          });
        }
        dispatch({ type: actionTypes.LOADING_STOP });
        return error;
      });
  };
};
export const update = department => {
  const obj = {
    Id: department.id,
    Name: department.name,
    Notes: department.notes,
  };
  return dispatch => {
    const userId = getUserInfo()?.selfUserId ?? null;
    const userInput = { departmentId: department?.id, hasName: !!department?.name, hasNotes: !!department?.notes };
    dispatch({ type: actionTypes.LOADING_START });
    return axiosBasic
      .put(Department.Update, obj)
      .then(response => {
        // API returns a base model: { success, message, data }
        const res = response.data;
        const success = res.success;
        if (typeof posthog !== "undefined" && posthog.capture) {
          posthog.capture("update", {
            type: success ? "info" : "exception",
            userId,
            success,
            userInput,
            reason: success ? undefined : res.message,
          });
        }
        if (success) {
          // Keep reducer logic simple by always passing the updated department object
          dispatch({
            type: actionTypes.UPDATE_DEPARTMENT_SUCCESS,
            department: res.data
          });
        }

        dispatch({ type: actionTypes.LOADING_STOP });
        return res;
      })
      .catch(error => {
        if (typeof posthog !== "undefined" && posthog.capture) {
          posthog.capture("update", {
            type: "exception",
            userId,
            success: false,
            userInput,
            reason: error?.response?.data?.message ?? error?.message ?? "Request failed",
          });
        }
        dispatch({ type: actionTypes.LOADING_STOP });
        return error;
      });
  };
};
export const Delete = department => {
  return dispatch => {
    const userId = getUserInfo()?.selfUserId ?? null;
    const userInput = { departmentId: department?.id };
    dispatch({ type: actionTypes.LOADING_START });
    axiosBasic
      .delete(Department.Delete + department.id)
      .then(response => {
        dispatch({ type: actionTypes.LOADING_STOP });
        const baseModel = response.data;
        const success = baseModel.success;
        if (typeof posthog !== "undefined" && posthog.capture) {
          posthog.capture("Delete", {
            type: success ? "info" : "exception",
            userId,
            success,
            userInput,
            reason: success ? undefined : baseModel.message,
          });
        }
        if (success) {
          dispatch(deleteDepartment(department)); // This now updates the local state via reducer
        } else {
          Common.showErrorMessage(baseModel.message);
        }
      })
      .catch(error => {
        if (typeof posthog !== "undefined" && posthog.capture) {
          posthog.capture("Delete", {
            type: "exception",
            userId,
            success: false,
            userInput,
            reason: error?.response?.data?.message ?? error?.message ?? "Request failed",
          });
        }
        dispatch({ type: actionTypes.LOADING_STOP });
        Common.showErrorMessage("Something went wrong");
      });
  };
};
